import { useParams } from "react-router-dom";
import Arrow from '../../assets/arrowTopRight.jsx';

export default function CMSLink({ path, icon, children }) {
  const { lang } = useParams();

  // Ensure no double slashes and handle external links
  const isExternal = path?.startsWith('http');
  const normalizedPath = path?.startsWith('/') ? path : `/${path}`;

  if (isExternal) {
    return <a href={path} target="_blank" rel="noopener noreferrer">{children}</a>;
  }

  return <a href={`/${lang}${normalizedPath}`}>{children} {icon == "arrow" && (<Arrow />)}</a>;
}
